// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./+not-found.tsx": { enumerable: true, get() { return require("/home/runner/work/login/login/src/app/+not-found.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/home/runner/work/login/login/src/app/_layout.tsx"); } },
  "./forgot-password.tsx": { enumerable: true, get() { return require("/home/runner/work/login/login/src/app/forgot-password.tsx"); } },
  "./impersonation-callback.tsx": { enumerable: true, get() { return require("/home/runner/work/login/login/src/app/impersonation-callback.tsx"); } },
  "./index.tsx": { enumerable: true, get() { return require("/home/runner/work/login/login/src/app/index.tsx"); } },
  "./magic-link-sent.tsx": { enumerable: true, get() { return require("/home/runner/work/login/login/src/app/magic-link-sent.tsx"); } },
  "./magic-link.tsx": { enumerable: true, get() { return require("/home/runner/work/login/login/src/app/magic-link.tsx"); } },
  "./maintenance.tsx": { enumerable: true, get() { return require("/home/runner/work/login/login/src/app/maintenance.tsx"); } },
  "./reset-password.tsx": { enumerable: true, get() { return require("/home/runner/work/login/login/src/app/reset-password.tsx"); } },
  "./signed-out.tsx": { enumerable: true, get() { return require("/home/runner/work/login/login/src/app/signed-out.tsx"); } },
  "./sso-callback.tsx": { enumerable: true, get() { return require("/home/runner/work/login/login/src/app/sso-callback.tsx"); } },
  "./sso-login.tsx": { enumerable: true, get() { return require("/home/runner/work/login/login/src/app/sso-login.tsx"); } },
  "./token-login.tsx": { enumerable: true, get() { return require("/home/runner/work/login/login/src/app/token-login.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;